import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';

interface AditoolsCardCheckboxArgs {
  Element: HTMLInputElement;
  Args: {
    qaName?: string;
    tooltip?: string;
    changed?: (event: Event) => void;
  };
}

export default class AditoolsCardCheckbox extends Component<AditoolsCardCheckboxArgs> {
  @service declare intl: IntlService;

  get qaName() {
    return this.args.qaName ?? 'unnamed';
  }

  get _tooltip() {
    return this.args.tooltip ?? this.intl.t('ember-aditools-page.card.checkbox-tooltip');
  }

  @action checkboxChanged(event: Event) {
    if (this.args.changed) {
      this.args.changed(event);
    }
  }
}
